import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { withPageBase } from '../PageBase';
import { get } from 'lodash';
import Row from '../tag/Row';
import Span from '../tag/Span';
import { FormattedMessage } from 'react-intl';
import Alert from '../Alert';
import BioBankAlert from './BioBankAlert';
import BioBankConsentModal from './BioBankConsentModal';
import BioBankRefusalModal from './BioBankRefusalModal';
import BioBankAgreementInfo from './BioBankAgreementInfo';
import BioBankAgreement from './BioBankAgreement';
import BioBankAgreement2 from './BioBankAgreement2';
import BioBankRefusal from './BioBankRefusal';
import { BIOBANK, USER } from '../../data/reducer';
import ToastHOC from '../ToastHOC';
import {
  doUpdateConsent,
  resetDocumentContent,
} from '../../data/biobank/actions';
import Loader from '../Loader';
import { hasActiveStatus, hasConsent } from '../../utils/BioBankUtil';

const { id: module_id } = module;

class BioBank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      refusalModalIsOpen: false,
      consentModalIsOpen: false,
      agreement: {
        page1Agreed: false,
      },
    };

    if (props.consentData) {
      this.initForm(props);
    }
  }

  /**
   * Biobank alert is shown if
   * - user is applicable to give biobank consent (18 or over)
   * - user has not yet given consent (CONSENT or REFUSAL)
   * - hpa is not used
   * @returns {*|boolean}
   */
  shouldShowBiobankAlert() {
    let { bioBankApplicable, consentData } = this.props;
    return bioBankApplicable && consentData && !hasActiveStatus(consentData);
  }

  componentDidMount() {
    let { consentData } = this.props;
    if (consentData) {
      this.initForm(this.props);
    }
  }

  componentDidUpdate(oldProps) {
    if (!this.props.consentData && oldProps.consentData) {
      this.initForm(oldProps);
    }
  }

  initForm = (props) => {
    if (hasConsent(props.consentData)) {
      this.setPage1Agreement(true);
    }
  };

  triggerRefusalModal = () => {
    this.setState({ refusalModalIsOpen: true });
  };

  triggerConsentModal = () => {
    this.setState({ consentModalIsOpen: true });
  };

  closeRefusalModal = (action) => {
    let { resetDocumentContent } = this.props;
    switch (action) {
      case 'next':
        resetDocumentContent('refusal');
        this.setState({ refusalModalIsOpen: false });
        this.props.history.push('/biobank/refusal');
        break;
      case 'cancel':
        this.setState({ refusalModalIsOpen: false });
        break;
    }
  };

  closeConsentModal = (action) => {
    let { resetDocumentContent } = this.props;
    switch (action) {
      case 'next':
        resetDocumentContent('currentConsent');
        resetDocumentContent('latestConsent');
        this.setState({ consentModalIsOpen: false });
        this.props.history.push('/biobank/consent/latest/1');
        break;
      case 'cancel':
        this.setState({ consentModalIsOpen: false });
        break;
    }
  };

  setPage1Agreement = (value) => {
    this.setState({
      agreement: {
        ...this.state.agreement,
        page1Agreed: value,
      },
    });
  };

  render() {
    let { consentData, error, toasts, isHpa, bioBankApplicable } = this.props;

    if (error) {
      return <Alert message={`${module_id}.error.fetching`} />;
    }

    if (!consentData && !get(this.props, 'isHpa')) {
      return <Loader />;
    }

    let toastElements = [];

    if (toasts) {
      toastElements = toasts.map((item) => <Alert {...item.spec} />);
    }

    return (
      <>
        {toastElements && (
          <Row>
            <Span>{toastElements}</Span>
          </Row>
        )}
        {this.shouldShowBiobankAlert() && <BioBankAlert />}
        {isHpa && (
          <Alert type="info" className="text-center">
            <FormattedMessage id={'biobank.hpa.consent.info'} />
          </Alert>
        )}
        {bioBankApplicable === false && (
          <Alert type="info" className="text-center">
            <FormattedMessage id={'biobank.consent.age.limit.info'} />
          </Alert>
        )}
        <Route
          exact
          path={`${this.props.match.url}`}
          render={(props) => (
            <BioBankAgreementInfo
              {...props}
              bioBankApplicable={bioBankApplicable}
              triggerRefusalModal={this.triggerRefusalModal}
              triggerConsentModal={this.triggerConsentModal}
            />
          )}
        />
        <Route
          path={`${this.props.match.url}/consent/:version/1`}
          render={(props) => (
            <BioBankAgreement
              agreement={this.state.agreement.page1Agreed}
              setAgreement={this.setPage1Agreement}
            />
          )}
        />
        <Route
          path={`${this.props.match.url}/consent/:version/2`}
          render={(props) => (
            <BioBankAgreement2 agreement={this.state.agreement.page1Agreed} />
          )}
        />
        <Route
          path={`${this.props.match.url}/refusal`}
          render={(props) => <BioBankRefusal {...props} />}
        />
        <BioBankRefusalModal
          isOpen={this.state.refusalModalIsOpen}
          closeModal={this.closeRefusalModal}
        />
        <BioBankConsentModal
          isOpen={this.state.consentModalIsOpen}
          closeModal={this.closeConsentModal}
        />
      </>
    );
  }
}

const title = `placeholder.biobank.title`;

const mapStateToProps = (state) => {
  return {
    consentData: state[BIOBANK].consentData.data,
    error: state[BIOBANK].consentData.error,
    bioBankApplicable: state[USER].userInfo.data.bioBankApplicable,
  };
};

const toastOptions = {
  module_id: module_id,
  dismissOnUnmount: ['APPOINTMENT_RESCHEDULE_FAILED_TOAST'],
};

export default withPageBase(
  connect(mapStateToProps, { resetDocumentContent, doUpdateConsent })(
    ToastHOC(toastOptions, BioBank)
  ),
  { title }
);
